// button属性： name、type、icon、plain（布尔值）、round（布尔值）、style样式（包含border、color、background三个样式属性）
// 获取表单或列表顶部查询按钮
export function setCheckButtons(names) {
  var buttons = []
  names.forEach((n) => {
    let name = ''
    let code = ''
    let icon = ''
    let type = 'primary'
    let plain = false
    let round = false
    let circle = false
    let style = null
    let button = {}
    if (typeof n === 'string') {
      name = n
    } else if (n && typeof n === 'object' && !Array.isArray(n)) {
      name = n.name
      code = n.code ? n.code : ''
      icon = n.icon ? n.icon : ''
      type = n.type ? n.type : 'primary'
      plain = n.plain ? n.plain : false
      round = n.round ? n.round : false
      circle = n.circle ? n.circle : false
      style = n.style ? n.style : {}
    }
    if (name.includes('批量')) {
      code = code ? code : 'batch'
    }
    if (
      name.includes('新增') ||
      name.includes('新建') ||
      name.includes('添加') ||
      name.includes('进场') ||
      name.includes('申报') ||
      name.includes('发布') ||
      name.includes('报备') ||
      name.includes('挂接') ||
      name.includes('补方') ||
      name.includes('创建')
    ) {
      code = code ? code : 'add'
      icon = icon ? icon : 'el-icon-plus'
    } else if (name.includes('入库')) {
      code = code ? code : 'add'
      icon = icon ? icon : 'el-icon-folder-add'
    } else if (name.includes('兑换')) {
      code = code ? code : 'add'
      icon = icon ? icon : 'el-icon-minus'
    } else if (name.includes('下载')) {
      code = code ? code : 'download'
      icon = icon ? icon : 'el-icon-download'
    } else if (name.includes('导入') || name.includes('上传')) {
      code = code ? code : 'upload'
      icon = icon ? icon : 'el-icon-upload'
    } else if (
      name.includes('编辑') ||
      name.includes('编制') ||
      name.includes('修改')
    ) {
      code = code ? code : 'edit'
      icon = icon ? icon : 'el-icon-edit'
    } else if (name.includes('更新')) {
      code = code ? code : 'update'
      icon = icon ? icon : 'el-icon-edit'
    } else if (
      name.includes('核查') ||
      name.includes('明细') ||
      name.includes('查看') ||
      name.includes('详情')
    ) {
      code = code ? code : 'check'
      icon = icon ? icon : 'el-icon-document-checked'
    } else if (name.includes('退回') || name.includes('拒绝')) {
      code = code ? code : 'confirm'
      icon = icon ? icon : 'el-icon-finished'
    } else if (
      name.includes('确认') ||
      name.includes('上报') ||
      name.includes('提交')
    ) {
      code = code ? code : 'confirm'
      icon = icon ? icon : 'el-icon-check'
    } else if (name.includes('生成')) {
      code = code ? code : 'generate'
      icon = icon ? icon : 'el-icon-finished'
    } else if (name.includes('复制')) {
      code = code ? code : 'copy'
      icon = icon ? icon : 'el-icon-copy-document'
    } else if (name.includes('刷新')) {
      code = code ? code : 'refresh'
      icon = icon ? icon : 'el-icon-refresh'
    } else if (name.includes('同步')) {
      code = code ? code : 'sync'
      icon = icon ? icon : 'el-icon-refresh'
    } else if (name.includes('对接')) {
      code = code ? code : 'docking'
      icon = icon ? icon : 'el-icon-sort'
    } else if (name.includes('保存')) {
      code = code ? code : 'save'
      icon = icon ? icon : 'el-icon-folder'
    } else if (name.includes('审核') || name.includes('审批')) {
      code = code ? code : 'approve'
      icon = icon ? icon : 'el-icon-check'
    } else if (name.includes('预览') || name.includes('附件')) {
      code = code ? code : 'preview'
      icon = icon ? icon : 'el-icon-search'
    } else if (name.includes('台帐') || name.includes('管理')) {
      code = code ? code : 'account'
      icon = icon ? icon : 'el-icon-document-add'
    } else if (name.includes('删除')) {
      code = code ? code : 'delete'
      icon = icon ? icon : 'el-icon-delete'
    } else if (name.includes('解禁')) {
      code = code ? code : 'unban'
      icon = icon ? icon : 'el-icon-unlock'
    } else if (name.includes('封禁')) {
      code = code ? code : 'ban'
      icon = icon ? icon : 'el-icon-lock'
    } else if (name.includes('解封')) {
      code = code ? code : 'unseal'
      icon = icon ? icon : 'el-icon-unlock'
    } else if (name.includes('封存')) {
      code = code ? code : 'seal'
      icon = icon ? icon : 'el-icon-lock'
    } else if (name.includes('配置')) {
      code = code ? code : 'set'
      icon = icon ? icon : 'el-icon-setting'
    } else if (name.includes('完善')) {
      code = code ? code : 'perfect'
      icon = icon ? icon : 'el-icon-finished'
    } else if (name.includes('标记')) {
      code = code ? code : 'markDefaultBid'
      icon = icon ? icon : 'el-icon-star-off'
    } else {
      code = code ? code : 'other'
    }
    if (name.includes('批量')) {
      icon = icon ? icon : 'el-icon-finished'
    }
    if (
      name === '批量退场' ||
      name === '导入薪酬' ||
      name === '导入考勤' ||
      name === '下载导入模板' ||
      name === '刷新' ||
      name === '验收单管理' ||
      name === '领用单管理' ||
      name === '导入明细' ||
      name === '标记默认标段' ||
      name === '批量删除'
    ) {
      type = ''
    }

    button = {
      code: code,
      name: name,
      type: type,
      icon: icon,
      plain: plain,
      round: round,
      circle: circle,
      style: style
    }
    buttons.push(button)
  })
  return buttons
}
// 获取列表行按钮
export function setTableButtons(names) {
  var buttons = []
  names.forEach((n) => {
    let name = ''
    let code = ''
    let type = ''
    let icon = ''
    let plain = false
    let round = true
    let circle = false
    let style = null
    let disabled = false
    if (typeof n === 'string') {
      name = n
    } else if (n && typeof n === 'object' && !Array.isArray(n)) {
      name = n.name ? n.name : ''
      code = n.code ? n.code : ''
      icon = n.icon ? n.icon : ''
      type = n.type ? n.type : ''
      plain = n.plain ? n.plain : false
      round = n.round ? n.round : true
      circle = n.circle ? n.circle : false
      style = n.style ? n.style : null
      disabled = !!n.disabled
    }
    if (
      name.includes('新增') ||
      name.includes('新建') ||
      name.includes('添加') ||
      name.includes('进场') ||
      name.includes('申报') ||
      name.includes('发布') ||
      name.includes('报备') ||
      name.includes('入库') ||
      name.includes('填报') ||
      name.includes('结算') ||
      name.includes('补方') ||
      name.includes('挂接') ||
      name.includes('整改')
    ) {
      code = code ? code : 'add'
    } else if (name.includes('导入') || name.includes('上传')) {
      code = code ? code : 'upload'
    } else if (name.includes('退回')) {
      code = code ? code : 'confirm'
    } else if (
      name.includes('确认') ||
      name.includes('上报') ||
      name.includes('提交')
    ) {
      code = code ? code : 'confirm'
    } else if (name.includes('生成')) {
      code = code ? code : 'generate'
    } else if (name.includes('复制') || name.includes('分批')) {
      code = code ? code : 'copy'
    } else if (name.includes('刷新')) {
      code = code ? code : 'refresh'
    } else if (name.includes('对接')) {
      code = code ? code : 'docking'
    } else if (
      name.includes('核查') ||
      name.includes('明细') ||
      name.includes('查看') ||
      name.includes('详情')
    ) {
      code = code ? code : 'check'
    } else if (
      name.includes('编辑') ||
      name.includes('编制') ||
      name.includes('修改')
    ) {
      code = code ? code : 'edit'
    } else if (name.includes('保存')) {
      code = code ? code : 'save'
    } else if (name.includes('审核') || name.includes('审批')) {
      code = code ? code : 'approve'
    } else if (name.includes('预览') || name.includes('附件')) {
      code = code ? code : 'preview'
    } else if (name.includes('台帐') || name.includes('管理')) {
      code = code ? code : 'account'
    } else if (name.includes('更新') || name.includes('变更')) {
      code = code ? code : 'update'
    } else if (name.includes('删除')) {
      code = code ? code : 'delete'
    } else if (name.includes('解禁')) {
      code = code ? code : 'unban'
    } else if (name.includes('封禁')) {
      code = code ? code : 'ban'
    } else if (name.includes('解封')) {
      code = code ? code : 'unseal'
    } else if (name.includes('封存')) {
      code = code ? code : 'seal'
    } else if (name.includes('配置')) {
      code = code ? code : 'set'
    } else if (name.includes('密码初始化')) {
      code = code ? code : 'resetPassWord'
    } else if (name.includes('办理')) {
      code = code ? code : 'handle'
    } else if (name.includes('打卡')) {
      code = code ? code : 'clock'
    } else if (name.includes('关联')) {
      code = code ? code : 'other'
      icon = icon ? icon : 'el-icon-connection'
    } else if (name.includes('退场') || name.includes('解散')) {
      code = code ? code : 'exit'
    } else if (name.includes('二维码')) {
      code = code ? code : 'qrcode'
    } else if (name.includes('推送')) {
      code = code ? code : 'pushing'
    } else if (name.includes('结果')) {
      code = code ? code : 'result'
    } else if (name.includes('展开')) {
      code = code ? code : 'expand'
    } else if (name.includes('监控')) {
      code = code ? code : 'device'
    } else if (name.includes('上移')) {
      code = code ? code : 'moveUp'
      icon = icon ? icon : 'el-icon-top'
    } else if (name.includes('下移')) {
      code = code ? code : 'moveDown'
      icon = icon ? icon : 'el-icon-bottom'
    } else if (name.includes('停用') || name.includes('启用')) {
      code = code ? code : 'toggle'
    } else {
      code = code ? code : 'other'
    }
    if (name === '变更' || name === '删除' || name === '修改' || name === '封存' || name === '封禁' || name === '停用') {
      style = style
        ? style
        : {
            border: '1px solid #FF6A40',
            color: '#FF6A40',
            background: '#ffffff'
          }
    } else if (
      name === '解封' ||
      name === '解禁' ||
      name === '启用' ||
      name === '完成生产'
    ) {
      style = style
        ? style
        : {
            border: '1px solid #67C23A',
            color: '#67C23A',
            background: '#ffffff'
          }
    } else if (name.includes('上移')) {
      style = style
        ? style
        : {
            border: '1px solid #4089FF',
            color: '#ffffff',
            background: '#4089FF'
          }
    } else if (name.includes('下移')) {
      style = style
        ? style
        : {
            border: '1px solid #F56C6C',
            color: '#ffffff',
            background: '#F56C6C'
          }
    } else if (name === '暂停' || name === '暂停生产') {
      style = style
        ? style
        : {
            border: '1px solid #F56C6C',
            color: '#ffffff',
            background: '#F56C6C'
          }
    } else if (name === '运输装车') {
      style = style
        ? style
        : {
            border: '1px solid #4089FF',
            color: '#ffffff',
            background: '#4089FF'
          }
    } else if (name === '置顶') {
      style = style
        ? style
        : {
            border: '1px solid #67C23A',
            color: '#67C23A',
            background: '#ffffff'
          }
    } else if (
      name === '二维码' ||
      name === '确认' ||
      name === '配置角色' ||
      name === '配置web权限' ||
      name === '结果' ||
      name === '预览' ||
      name === '上传' ||
      name === '附件' ||
      name === '补方' ||
      name === '签收' ||
      name.includes('复制') ||
      name.includes('复核') ||
      name === '验收' ||
      name.includes('填报') ||
      name === '整改'
    ) {
      style = style
        ? style
        : {
            border: '1px solid #4089FF',
            color: '#ffffff',
            background: '#4089FF'
          }
    } else if (
      name === '退场' ||
      name === '解散' ||
      name === '中止' ||
      name === '中止生产' ||
      name === '密码初始化' ||
      name === '配置app权限' ||
      name === '执行' ||
      name === '签到'
    ) {
      style = style
        ? style
        : {
            border: '1px solid #FF6A40',
            color: '#ffffff',
            background: '#FF6A40'
          }
    } else {
      style = style
        ? style
        : {
            border: '1px solid #4089FF',
            color: '#4089FF',
            background: '#ffffff'
          }
    }
    let button = {}
    button = {
      code: code,
      name: name,
      type: type,
      icon: icon,
      plain: plain,
      round: round,
      circle: circle,
      style: style,
      disabled: disabled
    }
    buttons.push(button)
  })
  return buttons
}
// 获取列表行按钮
export function setFormButtons(names) {
  var buttons = []
  names.forEach((name) => {
    let code = ''
    if (name === '提交') {
      code = 'post'
    } else if (name === '存草稿') {
      code = 'buffer'
    } else if (name === '取消' || name === '结算') {
      code = 'cancel'
    } else if (name === '新增') {
      code = 'add'
    } else if (name === '保存') {
      code = 'save'
    } else if (name === '编辑') {
      code = 'edit'
    } else if (name === '上 传') {
      code = 'upload'
    } else if (name === '重新生成') {
      code = 'regenerate'
    } else if (name === '本地上传') {
      code = 'localUpload'
    } else if (name === '电子签署') {
      code = 'electronicSign'
    } else if (name === '预 览' || name === '预览') {
      code = 'preview'
    } else if (name === '预览报表') {
      code = 'previewReport'
    } else if (name === '上一步') {
      code = 'back'
    } else if (name === '下一步') {
      code = 'next'
    } else if (name === '再次办理') {
      code = 'copy'
    } else if (name === '返回列表') {
      code = 'return'
    } else if (name === '生成签名') {
      code = 'generate'
    } else if (name === '同意') {
      code = 'approvePass'
    } else if (name === '拒绝') {
      code = 'approveReject'
    }

    let type = 'primary'
    if (
      name === '取消' ||
      name === '预 览' ||
      name === '预览' ||
      name === '上一步' ||
      name === '返回列表'
    ) {
      type = ''
    } else if (name === '拒绝') {
      type = 'danger'
    }

    let icon = ''
    if (code === 'add') {
      icon = 'el-icon-plus'
    } else if (code === 'save') {
      icon = 'iconfont icon-save-fill'
    } else if (code === 'edit') {
      icon = 'el-icon-edit'
    } else if (code === 'upload') {
      icon = 'el-icon-upload2'
    } else if (code === 'preview') {
      icon = 'el-icon-zoom-in'
    }

    let plain = false
    if (name === '存草稿' || name === '生成签名') {
      plain = true
    }

    let round = false
    let style = {}
    let button = {}
    button = {
      code: code,
      name: name,
      type: type,
      icon: icon,
      plain: plain,
      round: round,
      style: style
    }
    buttons.push(button)
  })
  return buttons
}
// 获取cardForm顶部按钮
export function getCardFormHeadButtons(type) {
  if (type === 0) {
    return (params) => {
      if (params.pageStatus === 'add' || params.pageStatus === 'adminAdd') {
        return setFormButtons(['新增'])
      } else if (
        params.pageStatus === 'edit' ||
        params.pageStatus === 'complete'
      ) {
        return setFormButtons(['保存'])
      } else if (params.pageStatus === 'check') {
        return setFormButtons(['编辑'])
      }
    }
  } else if (type === 1) {
    return (params) => {
      if (
        params.pageStatus === 'add' ||
        params.pageStatus === 'adminAdd' ||
        params.pageStatus === 'edit' ||
        params.pageStatus === 'complete'
      ) {
        return setFormButtons(['保存'])
      } else if (params.pageStatus === 'check') {
        return setFormButtons(['编辑'])
      }
    }
  }
}
// 获取stepForm底部按钮
export function getStepFormBottomButtons(type) {
  if (type === 0) {
    return (params) => {
      if (params.activeStep === 0) {
        return setFormButtons(['下一步'])
      } else if (params.activeStep === 1) {
        return setFormButtons(['上一步', '提交'])
      } else if (params.activeStep === 2) {
        return setFormButtons(['再次办理', '返回列表'])
      }
    }
  } else if (type === 1) {
    return (params) => {
      if (params.activeStep === 0) {
        return setFormButtons(['下一步'])
      } else if (params.activeStep === 1) {
        return setFormButtons(['上一步', '提交'])
      } else if (params.activeStep === 2) {
        return setFormButtons(['返回列表'])
      }
    }
  } else if (type === 2) {
    return (params) => {
      if (params.activeStep === 0) {
        return setFormButtons(['下一步'])
      } else if (params.activeStep === 1) {
        return setFormButtons(['上一步', '提交'])
      } else if (params.activeStep === 2) {
        return setFormButtons(['重新生成', '返回列表'])
      }
    }
  } else if (type === 3) {
    return (params) => {
      if (
        params.currentRow &&
        params.currentRow.subitemLevel === 'subprojectType'
      ) {
        if (params.activeStep === 0) {
          return setFormButtons(['下一步', '提交'])
        } else if (params.activeStep === 1) {
          return setFormButtons(['上一步', '提交'])
        }
      } else {
        return setFormButtons(['取消', '提交'])
      }
    }
  }
}
